import React, { useRef, useState } from 'react';
import StbButton, { StbButtonProps } from './StbButton';
import { toastError } from '../../../utilities/messageUtils';

interface AsyncStbButtonProps extends Omit<StbButtonProps, 'onClick'> {
  onClick: () => Promise<void>;
}

/** Keeps the action locked until its complete asynchronous workflow settles. */
const AsyncStbButton: React.FC<AsyncStbButtonProps> = ({ onClick, loading, disabled, ...props }) => {
  const running = useRef(false);
  const [pending, setPending] = useState(false);

  const handleClick = async () => {
    if (running.current || loading || disabled) return;
    running.current = true;
    setPending(true);
    try {
      await onClick();
    } catch (error) {
      toastError('Åtgärden kunde inte slutföras', error);
    } finally {
      running.current = false;
      setPending(false);
    }
  };

  return <StbButton {...props} disabled={disabled} loading={loading || pending} onClick={handleClick} />;
};

export default AsyncStbButton;
